import { render, staticRenderFns } from "./VTnC.vue?vue&type=template&id=75a8767a&scoped=true&"
import script from "./VTnC.vue?vue&type=script&lang=js&"
export * from "./VTnC.vue?vue&type=script&lang=js&"
import style0 from "./VTnC.vue?vue&type=style&index=0&id=75a8767a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a8767a",
  null
  
)

export default component.exports